@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;
    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;
    --primary: 222.2 47.4% 11.2%;
    --primary-foreground: 210 40% 98%;
    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;
    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;
    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;
    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 222.2 84% 4.9%;
    --radius: 0.5rem;
  }
}

/* ---------------------------------------------------------------------------
   Legacy control theming.

   Paints the native inputs behind components/shared/StandaloneCheckbox.jsx and
   StandaloneRadio.jsx, and replaces the .MuiCheckbox-* / .MuiRadio-* rules in
   css/stylesheet.css that went dead when @material-ui/core was removed. The
   colour rules have to live in CSS rather than in the components because they
   depend on ancestor classes (.card-disabled, .div-project-feature-listitem).

   These style native inputs rather than the Radix components in components/ui/.
   The original reason was that Radix could not be bundled under CRA 5; that is
   no longer true after the Vite migration, but native is kept on purpose — see
   the note in components/shared/StandaloneCheckbox.jsx. Revisit during the
   shadcn design-token pass.
   --------------------------------------------------------------------------- */

.t4t-checkbox,
.t4t-radio {
  -webkit-appearance: none;
  appearance: none;
  flex-shrink: 0;
  margin: 0;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid rgba(0, 0, 0, 0.54);
  cursor: pointer;
  outline: none;
}

/* MUI's icon was 24px inside a 42x42 button; the visible box was 18px. */
.t4t-checkbox {
  height: 18px;
  width: 18px;
  border-radius: 2px;
}

.t4t-radio {
  height: 20px;
  width: 20px;
  border-radius: 9999px;
}

.t4t-checkbox:checked {
  background-color: var(--brand-color1);
  border-color: var(--brand-color1);
  background-size: 100% 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23fff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='3.5 8.5 6.5 11.5 12.5 4.5'/%3E%3C/svg%3E");
}

.t4t-radio:checked {
  border-color: var(--brand-color1);
  background-image: radial-gradient(
    circle at center,
    var(--brand-color1) 0 5px,
    transparent 5px
  );
}

/* Disabled and UNCHECKED. MUI rendered this state at rgba(0,0,0,0.26); the native
   port originally only handled checked:disabled, so an unchecked disabled control was
   indistinguishable from an enabled one — no feedback that the option was unavailable. */
.t4t-checkbox:disabled,
.t4t-radio:disabled {
  cursor: not-allowed;
  border-color: rgba(0, 0, 0, 0.26);
}

/* Disabled, or anywhere inside a .card-disabled container, greys out. */
.t4t-checkbox:checked:disabled,
.card-disabled .t4t-checkbox:checked {
  background-color: grey;
  border-color: grey;
}

.t4t-radio:checked:disabled,
.card-disabled .t4t-radio:checked {
  border-color: grey;
  background-image: radial-gradient(
    circle at center,
    grey 0 5px,
    transparent 5px
  );
}

/* Driver feature list: grey while the row is unselected, brand once selected. */
.div-project-feature-listitem .t4t-checkbox:checked {
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}

.div-project-feature-listitem-selected .t4t-checkbox:checked {
  background-color: var(--brand-color1);
  border-color: var(--brand-color1);
}

/* The two contexts that shrank MUI's icon from 1.5rem to 1.25rem. */
.div-project-feature-listitem .t4t-checkbox,
.div-project-feature-listitem-selected .t4t-checkbox,
.switch-opMode .t4t-checkbox,
.switch-opMode-selected .t4t-checkbox {
  height: 15px;
  width: 15px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
